module.exports = __webpack_public_path__ + "static/media/18ECA29.dd9d9b4e.jpg";